import React, { useState, useEffect } from "react";
import audioImg from "../Assets/images/dashboard/audio.svg";
import assessmentsImg from "../Assets/images/dashboard/doctor.svg";
import Popup from "./Popup";
import { connect } from "react-redux";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { fetchPatients } from "../Actions";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import moment from "moment";

const ValidationHome = (props) => {
  let date = moment(new Date());
  // const [endDate, setEndDate] = useState(
  //   new Date(date.add(1, "day").valueOf())
  // );
  // const [startDate, setStartDate] = useState(
  //   new Date(date.subtract(1, "month").valueOf())
  // );

  const [dateRange, setDateRange] = useState({
    startDate: new Date(date.subtract(1, "week").valueOf()),
    endDate: new Date(date.add(7, "day").valueOf()),
  });

  const [data, setData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dates1, setDates1] = useState("");
  const [dates2, setDates2] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [oneWeekPressed, setOneWeekPressed] = useState(false);
  const [oneMonthPressed, setOneMonthPressed] = useState(true);
  // const [completedPatients, setCompletedPatients] = useState(0)

  const filtereddata = React.useMemo(() => {
    props.patient.patient.filter(function (s) {
      return s.userId === props.doctors.agentId;
    });
  }, [props.patient.patient]);

  const rawdata = React.useMemo(
    () => props.patient.patient,
    [props.patient.patient]
  );

  useEffect(() => {
    setShowPopup(true);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
    const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");

    if (dateRange.endDate !== null && dateRange.startDate !== null) {
      setLoading(true);

      props.fetchPatients(endDate1, startDate1).then(() => setLoading(false));
      setData(
        localStorage.getItem("user") === "admin"
          ? props.doctors.agentId
            ? filtereddata
            : rawdata
          : rawdata
      );
      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
    } else {
      props.fetchPatients("", "").then(() => setLoading(false));
      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
    }
    // setLoading(false);
  }, [dateRange.endDate, dateRange.startDate]);

  const oneWeekHandler = () => {
    setOneWeekPressed(true);
    setOneMonthPressed(false);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    // setStartDate(new Date(newStartdate.subtract(7, "day").valueOf()));
    // setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
    setDateRange({
      startDate: new Date(newStartdate.subtract(7, "day").valueOf()),
      endDate: new Date(newEnddate.add(1, "day").valueOf()),
    });
  };

  const oneMonthHandler = () => {
    setOneWeekPressed(false);
    setOneMonthPressed(true);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    // setStartDate(new Date(newStartdate.subtract(1, "month").valueOf()));
    // setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
    setDateRange({
      startDate: new Date(newStartdate.subtract(1, "month").valueOf()),
      endDate: new Date(newEnddate.add(1, "day").valueOf()),
    });
  };

  const oneDayHandler = () => {
    setSelectedOption("1day");
    const today = moment().startOf("day").toDate();
    // setStartDate(today); // Set start date to today
    // setEndDate(today); // Set end date to today
    setDateRange({ startDate: today, endDate: today });
  };
  const oneYearHandler = () => {
    setSelectedOption("1year");
    const startDate = moment().subtract(1, "year").toDate();
    const endDate = moment().toDate();
    // setStartDate(startDate); // Set start date 1 year ago
    // setEndDate(endDate); // Set end date to end of this year
    setDateRange({ startDate: startDate, endDate: endDate });
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    // Call respective handler functions based on selected option
    if (value === "1week") {
      oneWeekHandler();
      setShowDatePicker(false);
    } else if (value === "1day") {
      oneDayHandler();
      setShowDatePicker(false);
    } else if (value === "1month") {
      oneMonthHandler();
      setShowDatePicker(false);
    } else if (value === "1year") {
      oneYearHandler();
      setShowDatePicker(false);
    } else if (value === "custom") {
      setShowDatePicker(true);
    }
  };

  const handleRangeSelected = (args) => {
    const startDate1 = args.value[0];
    const endDate1 = args.value[1];

    const startDate2 = moment(startDate1).format("YYYY-MM-DD");
    const endDate2 = moment(endDate1).format("YYYY-MM-DD");

    setDateRange({ startDate: startDate2, endDate: endDate2 });
    setDates1(startDate2.toLocaleString());
    setDates2(endDate2.toLocaleString());

    setSelectedOption("");
  };

  const handleDateRangePickerRef = (ref) => {
    if (ref && selectedOption === "custom") {
      ref.show();
    }
  };

  return (
    <>
      <div>
        <div className="dateSelection">
          <select
            className="selectDate"
            id="duration"
            value={selectedOption}
            onChange={handleChange}
          >
            <option>Date Range</option>
            <option value="1day">1 Day</option>
            <option value="1week">1 Week</option>
            <option value="1month">1 Month</option>
            <option value="1year">1 Year</option>
            <option value="custom" key="">
              Custom
            </option>
          </select>
          {showDatePicker && (
            <div className="dateRangePicker">
              <DateRangePickerComponent
                id="daterangepicker"
                placeholder="Select a range"
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                showClearButton={false}
                onChange={handleRangeSelected}
                ref={(ref) => handleDateRangePickerRef(ref)}
              />
            </div>
          )}
          <div className="dates-container">
            <p className="dates">{moment(dates1).format("DD-MM-YYYY")} </p>
            <p className="dates">to</p>
            <p className="dates">{moment(dates2).format("DD-MM-YYYY")} </p>
          </div>
        </div>

        {loading ? (
          <>
            <div
              style={{
                display: "flex",
                gap: "17px",
                marginLeft: "10px",
                marginBottom: "15px",
              }}
            >
              <ShimmerThumbnail
                height={230}
                width={600}
                className="m-0"
                rounded
              />
              <ShimmerThumbnail
                height={230}
                width={600}
                className="m-0"
                rounded
              />
            </div>
            <div style={{ display: "flex", gap: "17px", marginLeft: "10px" }}>
              <ShimmerThumbnail
                height={230}
                width={600}
                className="m-0"
                rounded
              />
              <ShimmerThumbnail
                height={230}
                width={600}
                className="m-0"
                rounded
              />
            </div>
          </>
        ) : (
          <div className="dashboard__patientsummary">
            <div className="patient-card">
              <div className="card2--info__content">
                <p className="card2--info__title">Total Patients Scanned</p>
                <img
                  style={{ width: "130px", height: "80px" }}
                  src={audioImg}
                  alt="patients"
                />
                <p className="card2--info__count">{props.patient.count}</p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#46360999" }}
              >
                Total number of patients registered in the selected location &
                Date range.
              </p>
            </div>
            <div className="patient-card card2--assessments">
              <div className="card2--info__content">
                <p className="card2--info__title">Total patients completed</p>
                <img
                  style={{ width: "130px", height: "80px" }}
                  src={assessmentsImg}
                  alt="assessments"
                />
                <p className="card2--info__count">
                  {props.patient.completed_patients
                    ? props.patient.completed_patients
                    : 0}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#1ad94799" }}
              >
                Number of patients who have completed study for selected
                location & Date range.
              </p>
            </div>
            <div className="patient-card card2--assessments">
              <div className="card2--info__content">
                <p className="card2--info__title">Total Assessments</p>
                <img
                  style={{ width: "130px", height: "80px" }}
                  src={assessmentsImg}
                  alt="assessments"
                />
                <p className="card2--info__count">
                  {props.patient.assessment_count}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#1ad94799" }}
              >
                Number of Assessments for selected location & Date range.
              </p>
            </div>
            <div className="patient-card card2--assessments">
              <div className="card2--info__content">
                <p className="card2--info__title">Valid Patients</p>
                <img
                  style={{ width: "130px", height: "80px" }}
                  src={assessmentsImg}
                  alt="assessments"
                />
                <p className="card2--info__count">
                  {props.patient.valid_patients_count}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#1ad94799" }}
              >
                Number of valid Patients for selected location & Date range.
              </p>
            </div>
          </div>
        )}
      </div>
      {loading ? (
        <></>
      ) : (
        <Popup
          message="Hi, I am here to assist you"
          onClose={closePopup}
          show={showPopup}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  patient: state.patient,
  doctors: state.doctors,
});

export default connect(mapStateToProps, { fetchPatients })(ValidationHome);
